
import { Vue, Component, Prop } from 'vue-property-decorator';

import WLBrand from '../WLBrand.vue';
import { NavLink, TopNavLink, ILogo } from './types';
import { isLogo } from '../../utils/typeGuard';
import flatten from 'lodash/flatten';

@Component({ components: { WLBrand } })
export default class WLBurgerMenu extends Vue {
  @Prop()
  private navLinks?: NavLink[];

  @Prop()
  private topNavLinks?: TopNavLink[];

  @Prop()
  private logo!: ILogo | string;

  @Prop()
  private title!: string;

  private drawer = false;

  get flattenNavLinks() {
    return flatten(this.navLinks);
  }

  get logoSrc() {
    return isLogo(this.logo) ? this.logo.src : this.logo;
  }

  get logoCss() {
    return `
      height:100%;
      background-image:url('${isLogo(this.logo) ? this.logo.src : this.logo}');
      background-position: center center;
      background-size: contain;
      min-width:
      ${isLogo(this.logo) ? this.logo.width : 150};
      background-repeat:no-repeat
    `;
  }
}
